import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import { ActionInterface } from "../../Interface/ActionInterface";
import Auth from "../../Auth/Auth";
import Translator from "../../Translation/Translator";
import SignupActions from "../../Action/Actions/SignupActions";

export default function* signup(action: ActionInterface): any {
  try {
    yield put(SignupActions.request());

    const requiredFields = action.payload?.fields.filter(field => {
      return field.value.length < 2;
    });

    if (requiredFields.length > 0) {
      yield put(
        SignupActions.failure(
          Translator.trans("error-this-field-is-required"),
          requiredFields.map(field => field.field)
        )
      );
      return;
    }

    const res = yield call(Auth.signup, action.payload?.data);
    // const user: PersonInterface = PersonFactory.create(res);
    // const settings: UserSettingsInterface = UserSettingsFactory.create(res.userSettings[0]);

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res);
    }

    yield put(SignupActions.success());


    // We decide to not register user and start app, instead only present dialog for user with instruction to set password and confrim email, and than start app.
    // yield put(UserActions.auth(user, settings));
    // yield put(TokenActions.update(res.token));
    // yield AuthSequence();
    // yield put({
    //   type: Constants.POST_PROCESS_SIGN_UP_MESSAGE,
    //   payload: {
    //     postProcessSignUpPopupOpenMessage: res.email
    //   }
    // });

    // CASA-7867
    yield put({
      type: Constants.SNACKBAR_CLEAR_MESSAGES
    });



    // browserHistory.push("/app/dashboard/overview");
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
    yield put(SignupActions.failure(err.translatedMessage, err.fields));
  }
}

export function* watchSignUp() {
  yield takeEvery(Constants.PAGE_SIGNUP_START, signup);
}
